/**
 * Whether a meeting/call room is mounted on this page. The sign-in guard reads it: while you're in a call
 * it must never navigate the page away to the sign-in screen (the media is peer-to-peer and keeps working
 * on an expired token); the redirect waits until the call ends.
 */
let activeCalls = 0;
const listeners = new Set<() => void>();

export function enterCall(): () => void {
    activeCalls += 1;
    emit();
    let left = false;
    return () => {
        if (left) return;
        left = true;
        activeCalls = Math.max(0, activeCalls - 1);
        emit();
    };
}

export function isInCall(): boolean {
    return activeCalls > 0;
}

export function onCallStateChange(listener: () => void): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}

function emit() {
    for (const l of Array.from(listeners)) l();
}
